import processPolyfill from 'process/browser';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// CRA5/webpack5 dropped the automatic Node core-module polyfills webpack4
// used to inject. simple-peer's dependency `readable-stream` still expects
// a global `process` (it calls `process.nextTick` internally, including
// during `peer.destroy()` on call end), so without this it throws
// "process is not defined" the moment a video call is ended/left.
window.process = window.process || processPolyfill;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('PWA: App is ready for offline use');
  },
  onUpdate: (registration) => {
    console.log('PWA: New version available');
    // Optionally show update notification to user
    if (window.confirm('New version available! Click OK to update.')) {
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      }
    }
  }
});
